import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import useApi from "../../../hooks/useApi";

const ModalEditarCategoria = ({ categoria, updateCategorias }) => {
    const api = useApi();
    const { closeModal } = useModal();

    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState(categoria?.nome ?? "");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("uuid", categoria.uuid);
            formData.append("categoria", nome);

            await api.post("/Painel/API/Desvios/UpdateCategoria/", formData);
            await updateCategorias();
            closeModal();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Overlay state={true}>
            <Modal header close={closeModal}>
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="CATEGORIA"
                        type="text"
                        placeholder="DIGITE..."
                        valor={nome}
                        changeFunc={(e) => setNome(e.target.value.toUpperCase())}
                        required
                    />
                    <FormComp valor={loading ? "SALVANDO…" : "SALVAR"} type="submit" />
                </Formulario>
            </Modal>
            {loading && (
                <Overlay state={true}>
                    <Modal size="sm">
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </Overlay>
    );
};

export default ModalEditarCategoria;
